export const ADD_RWAMEMBER_INIT_ACTION = "ADD_RWAMEMBER_INIT_ACTION";
export const ADD_RWAMEMBER_SUCCESS_ACTION =
  ADD_RWAMEMBER_INIT_ACTION + "_SUCCESS";
export const ADD_RWAMEMBER_FAIL_ACTION =
  ADD_RWAMEMBER_INIT_ACTION + "_ERROR";

export const FETCH_INVOICEPAYMENTDATA_INIT_ACTION = "FETCH_INVOICEPAYMENTDATA_INIT_ACTION";
export const FETCH_INVOICEPAYMENTDATA_SUCCESS_ACTION =
  FETCH_INVOICEPAYMENTDATA_INIT_ACTION + "_SUCCESS";
export const FETCH_INVOICEPAYMENTDATA_FAIL_ACTION =
  FETCH_INVOICEPAYMENTDATA_INIT_ACTION + "_ERROR";

export const FETCH_INVOICEPAYMENTDETAILS_INIT_ACTION = "FETCH_INVOICEPAYMENTDETAILS_INIT_ACTION";
export const FETCH_INVOICEPAYMENTDETAILS_SUCCESS_ACTION =
  FETCH_INVOICEPAYMENTDETAILS_INIT_ACTION + "_SUCCESS";
export const FETCH_INVOICEPAYMENTDETAILS_FAIL_ACTION =
  FETCH_INVOICEPAYMENTDETAILS_INIT_ACTION + "_ERROR";

export const FETCH_INVOICEPAYMENTCHECKDETAILS_INIT_ACTION = "FETCH_INVOICEPAYMENTCHECKDETAILS_INIT_ACTION";
export const FETCH_INVOICEPAYMENTCHECKDETAILS_SUCCESS_ACTION =
  FETCH_INVOICEPAYMENTCHECKDETAILS_INIT_ACTION + "_SUCCESS";
export const FETCH_INVOICEPAYMENTCHECKDETAILS_FAIL_ACTION =
  FETCH_INVOICEPAYMENTCHECKDETAILS_INIT_ACTION + "_ERROR";

export const ADD_INVOICE_PAYMENT_INIT_ACTION = "ADD_INVOICE_PAYMENT_INIT_ACTION";
export const ADD_INVOICE_PAYMENT_SUCCESS_ACTION =
  ADD_INVOICE_PAYMENT_INIT_ACTION + "_SUCCESS";
export const ADD_INVOICE_PAYMENT_FAIL_ACTION =
  ADD_INVOICE_PAYMENT_INIT_ACTION + "_ERROR";